<template>
  <div class="otp-input">
    <input
      ref="input"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="6"
      class="form-control otp-input__field"
      :value="value"
      :disabled="disabled"
      :class="{'alert-danger': hasError}"
      placeholder="------"
      @input="onInput"
      @paste="onPaste" />
    <span v-if="hasError" class="error-message-forms">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  name: 'OtpInput',
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' }
  },
  methods: {
    /**
     * Filter to digits, cap at 6 characters and emit the cleaned value
     * upward so v-model stays in sync. Auto-submits to the parent when
     * the field reaches a full code, which keeps the UX tight without
     * the user needing to hit a submit button after typing the 6th digit.
     */
    onInput (event) {
      const cleaned = String(event.target.value || '').replace(/\D/g, '').slice(0, 6)
      event.target.value = cleaned
      this.$emit('input', cleaned)
      if (cleaned.length === 6) {
        this.$emit('complete', cleaned)
      }
    },
    /**
     * Accept whole codes pasted from clipboard. Without this, paste
     * inserts non-digit characters from formatted emails (e.g. spaces)
     * and the field shows blanks.
     */
    onPaste (event) {
      event.preventDefault()
      const text = (event.clipboardData || window.clipboardData).getData('text')
      const cleaned = String(text || '').replace(/\D/g, '').slice(0, 6)
      this.$emit('input', cleaned)
      if (cleaned.length === 6) {
        this.$emit('complete', cleaned)
      }
    },
    /** Focus the field; called by the parent when entering the OTP step. */
    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>

<style scoped>
.otp-input__field {
  text-align: center;
  letter-spacing: 8px;
  font-size: 24px;
  font-family: 'Roboto Mono', monospace;
}
</style>
